<template lang="html">
  <si-container>
    <v-flex xs12>
      <v-card>
        <v-card-title class="white pt-0">
          <v-scale-transition>
            <v-layout
              v-if="(selectedRows || {}).length > 0"
              align-center
              ma-0
              fill-height
            >
              <v-btn
                text
                color="grey"
                class="mt-4"
                @click="deleteSelected"
              >
                <v-icon left>
                  delete
                </v-icon> Delete {{ selectedRows.length }} logs
              </v-btn>
              <SiDeleteButton
                title="Delete all logs?"
                message="Are you sure you would like to delete all logs?"
                @delete="deleteAll"
              >
                <template #activator="{ on }">
                  <v-btn
                    text
                    color="grey"
                    class="mt-4"
                    v-on="on"
                  >
                    <v-icon left>
                      delete_sweep
                    </v-icon> Delete all logs
                  </v-btn>
                </template>
              </SiDeleteButton>
              <v-btn
                text
                color="grey"
                class="mt-4"
                @click="selectedRows = []"
              >
                <v-icon left>
                  block
                </v-icon>cancel
              </v-btn>
            </v-layout>
          </v-scale-transition>
          <v-spacer />
          <v-flex
            xs12
            sm6
            md4
            lg4
            pa-0
          >
            <v-text-field
              v-model="search"
              prepend-icon="search"
              label="Search"
              single-line
              clearable
              hide-details
            />
          </v-flex>
        </v-card-title>

        <v-data-table
          v-model="selectedRows"
          :headers="headers"
          :items="sortedlogs"
          :items-per-page="15"
          sort-by="timestamp"
          sort-desc
          :show-select="showSelect"
          :footer-props="{itemsPerPageOptions: [15, 50, 100, -1]}"
          class="si-error-table"
          :search="search"
          :expanded.sync="expanded"
          @click:row="expandRow"
        >
          <!-- <template v-slot:header.icon="{ item }">
          <v-icon @click="showSelect = !showSelect">block</v-icon>
        </template> -->
          <template #item.type="{ item }">
            <div
              :class="{'error--text': $route.query.logId === item.id}"
              class="cursor-pointer"
            >
              <v-icon
                v-if="item.type === 'error'"
                color="error"
              >
                warning
              </v-icon>
              <v-icon
                v-else-if="item.type === 'info'"
                color="info"
              >
                info
              </v-icon>
              <v-icon
                v-else
                color="grey"
              >
                outlined_flag
              </v-icon>
            </div>
          </template>
          <template #item.timestamp="{ item }">
            <div
              class="text-no-wrap  text-truncate cursor-pointer"
              :class="{'error--text': $route.query.logId === item.id, 'pl-2': $vuetify.breakpoint.xsOnly}"
            >
              {{ _formatDateTime(item.timestamp) }}
            </div>
          </template>
          <template #item.source="{ item }">
            <div
              class="text-no-wrap text-truncate cursor-pointer"
              :class="{'error--text': $route.query.logId === item.id, 'font-italic grey--text': !item.source, 'pl-2': $vuetify.breakpoint.xsOnly}"
            >
              {{ item.source || 'anonymous' }}
            </div>
          </template>
          <!-- <template v-slot:item.expand="{ item }">
          <v-icon v-if="item.stack && $vuetify.breakpoint.smAndUp" class="cursor-pointer" :class="{'si-rotate-180': expanded.includes(item)}">expand_more</v-icon>
        </template> -->
          <template #item.message="{ item }">
            <div
              v-if="$vuetify.breakpoint.smAndUp"
              style="font-family: monospace,monospace;"
              class="text-truncate cursor-pointer"
              :class="{'error--text': $route.query.logId === item.id}"
            >
              {{ item.message }}
            </div>
            <div
              v-else
              style="font-family: monospace,monospace;"
              class="text-truncate cursor-pointer pl-2"
              :class="{'error--text': $route.query.logId === item.id}"
            >
              {{ item.message.substring(0, 50) }}...
            </div>

            <!-- <span class="text-truncate">{{item.message}}</span> -->
          </template>

          <template #expanded-item="{ item, headers }">
            <td
              :colspan="headers.length"
              class="grey lighten-3"
            >
              <div :class="{'error--text': $route.query.logId === item.id}">
                <v-flex
                  xs12
                  style="overflow-x: auto;"
                >
                  <pre class="si-error-preview">{{ item.message }}</pre>
                  <pre
                    v-if="item.stack"
                    class="si-error-preview mt-4"
                  >{{ item.stack }}</pre>
                </v-flex>
              </div>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
  </si-container>
</template>

<script>
import { forEach } from 'lodash'
import { rtdb } from '@/plugins/firebase'
import helpers from '@/mixins/helpers'
import binder from '@/mixins/binder'
import seen from '@/mixins/seen'

export default {
  mixins: [ helpers, binder, seen ],
  props: {

  },
  data () {
    return {
      logs: {},
      selectedRows: [],
      search: '',
      showSelect: true,
      headers: [
        { text: '', value: '', sortable: false, width: '54' },
        { text: '', value: 'type', width: '54' },
        { text: 'Timestamp', value: 'timestamp', width: '160' },
        { text: 'Source', value: 'source', width: '240' },
        // { text: '', value: 'expand', width: '10'},
        { text: 'Log', value: 'message', sortable: false, width: '100%' },
      ],
      errorExpand: {},
      expanded: []
    }
  },
  computed: {
    // ...mapGetters([]),
    sortedlogs () {
      return this._sortObject(this.logs, 'timestamp') || []
    }
  },
  watch: {
    logs () {
      if (this.$route.query.logId) this.expanded.push(this.logs[this.$route.query.logId])
    },
    '$route.query.logId' (v) {
      if (v) this.expanded.push(this.logs[this.$route.query.logId])
    }
  },
  beforeMount () {
    this.$bindRtdb('logs', 'logs', { loader: true })
    // this.$bindxxx(rtdb.ref(`logs`), 'logs', true)
    this.$store.commit('set_appBarTitle', {title: 'Logs', icon: 'chrome_reader_mode'})
    this.expandLog(this.$route.query.logId)
  },
  mounted () {
    this._seenUpdate('errors')
  },
  methods: {
    expandRow (item) {
      // if (!item.stack) return
      if (this.expanded.includes(item)) {
        let index = this.expanded.indexOf(item)
        this.expanded.splice(index, 1)
      } else {
        this.expanded.push(item)
      }
    },
    expandLog () {
      let error = this.logs[this.$route.query.logId]
      this.expanded.push(error)
    },
    deleteSelected () {
      let updates = {}
      forEach(this.selectedRows, log => {
        updates[`logs/${log.id}`] = null
      })
      rtdb.ref().update(updates)
        .then(() => {
          this.selectedRows = []
        })
    },
    deleteAll () {
      rtdb.ref('logs').set(null)
        .then(() => {
          this.selectedRows = []
        })
    }
  }
}
</script>

<style lang="css">
.mystyle:first-line {
    line-height: 0px;
}
.si-error-table table {
  table-layout: fixed;
}
.si-rotate-180 {
  transform: rotate( -180deg );
  transition: transform 200ms ease;
}
/* pre.si-error-preview {
 white-space: pre-wrap;
 white-space: -moz-pre-wrap;
 white-space: -pre-wrap;
 white-space: -o-pre-wrap;
 word-wrap: break-word;
} */
</style>
